<template>
  <div class="d-submit-your-book panel panel-thick background-grey-medium">
    <img
      width="140"
      :src="imageSrc"
      alt="Gain exposure to thousands of readers in your genre"
    >

    <strong>
      Gain exposure to thousands of readers in your genre.
    </strong>

    <a
      class="button button-full button-yellow space-top-1em"
      :href="submitBookurl"
      title="Submit your book"
    >
      Submit your book
    </a>
  </div>
</template>

<script>
import USER_REVIEWS_IMG from '@d-assets/user-reviews.svg';
import URLS from '@d-shared/urls/urls';

export default {
  data: () => ({
    submitBookurl: URLS.app.author.submissions,
    imageSrc: USER_REVIEWS_IMG,
  }),
};
</script>

<style lang="scss">
.d-submit-your-book {
  img {
    display: block;
    margin: 0 auto;
  }
}
</style>
